import { Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { DateFormatPipe, MomentModule } from 'ngx-moment';
import { ItemDetails } from 'src/app/models/item-details';
import { CustomerNamePipe } from 'src/app/shared/pipes/customer-name.pipe';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-bookings',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    RouterLink,
    MomentModule
  ],
  providers: [DateFormatPipe, CustomerNamePipe],
  template: `
    <div
      class="flex flex-col justify-start items-stretch gap-3 p-4 bg-white rounded-lg shadow-sm border border-slate-200"
    >
      <div
        class="flex flex-row justify-start items-center gap-x-3 pb-2 border-b border-slate-100"
      >
        <mat-icon class="text-purple-500">event</mat-icon>
        <h2 class="text-lg font-bold text-slate-800">Bookings</h2>
      </div>
      @if (!hasBookings()) {
        <div class="flex items-center justify-center py-6">
          <p class="text-slate-500 italic flex items-center gap-2">
            <mat-icon class="text-slate-400">info</mat-icon>
            No upcoming bookings
          </p>
        </div>
      } @else {
        <div class="flex flex-col gap-2 p-3 rounded-md  transition-colors">
          <div class="flex flex-row items-center justify-between">
            <h3 class="font-medium text-slate-700">Next booking</h3>
          </div>
          <div
            class="flex flex-row items-center justify-between gap-2 p-2 rounded-md hover:bg-purple-100"
          >
            <div class="flex flex-col text-slate-700">
              <span class="font-medium">{{ nextBooking().customerName }}</span>
              <span class="text-sm text-slate-500">
                {{ nextBooking().on_hire | amDateFormat: dateFormat }} -
                {{ nextBooking().off_hire | amDateFormat: dateFormat }}
              </span>
            </div>
            <a
              [routerLink]="['/bookings/view', nextBooking().id]"
              mat-icon-button
              matTooltip="View booking details"
              class="text-sm text-purple-600 hover:text-purple-800"
            >
              <mat-icon>link</mat-icon>
            </a>
          </div>
        </div>
      }
    </div>
  `
})
export class BookingsComponent {
  itemDetails = input.required<ItemDetails>();
  dateFormat = ConfigService.dates.shortDateTimeFormat;

  nextBooking = computed(() => this.itemDetails().nextBooking);
  hasBookings = computed(() => this.nextBooking() !== null);

  viewAllBookings() {
    // This would typically navigate to a bookings view or open a dialog
    console.log('View all bookings clicked');
  }
}
